module.exports = __webpack_public_path__ + "static/media/logo.47fa6382.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.png
// module id = 693
// module chunks = 0